import React, { Component } from 'react';
import Config from './Config';
import { Scrollbars } from 'react-custom-scrollbars';
import List from './List';
import Modal from './Modal';
import Calendar from './Calendar';
//import Confirm from './Confirm';
import ComboBox from './ComboBox';
import './css/Delivery.css';
import SearchBox from './SearchBox';
import ContextMenu from './ContextMenu';
import FX from './functions/functions';

let apiHost = process.env.NODE_ENV === 'production' ? 'https://api.vdepot.co.uk' : 'https://api.dev.vdepot.co.uk';

class Delivery extends Component {
  constructor(props) {
  super(props)
    this.state = {activeItem: null, showSide:true, context: {show:false}, options:{}, stockCount: false, additionalItem: false, page: 0 };
    FX.urlRetrieve.bind(this)(this.props.root.state);
    this.props.root.autoKey = (e) => {
      if(this.props.root.state.detail){
          if(e.target.tagName === 'BODY'){
              document.getElementById('item_search').value = '';
              document.getElementById('item_search').focus();
          }
          if(e.key === 'Enter'){
              console.log(e.target.id.split("_")[0]);
              console.log(this.enterAction);
              if(typeof this.enterAction[e.target.id.split("_")[0]] === 'function'){
                 this.enterAction[e.target.id.split("_")[0]](e);
              }
              else if(document.getElementById('item_search').value) {
                  var searchBarcode;
                  searchBarcode = document.getElementById('item_search').value;
                  this.props.root.state.detail.delivery_items.some((di) => {
                      if(di.product.barcode === searchBarcode){
                        console.log(di);
                        this.showProductModal(di.product.id);
                        return di;
                      }
                      return false;
                  })
                  document.getElementById('item_search').value = '';
              }
          }
      }
      else{
        console.log(e);
      }
      console.log('xxx');
        console.log(e);
    }
  }
  setPage = page => {
    console.log(this.state.page);
    console.log(page);
    if(page.action === '+1'){
      page.action = this.state.page + 1;
    }
    else if(page.action === '-1'){
      page.action = this.state.page -1;
    }
    console.log(page);
    this.retrieveData(30, page.action);
  }
  componentDidUpdate(prevprops, prevstate){
    console.log(prevstate);
    console.log(prevprops);
    console.log(this.props.root.state.detail);
    console.log(prevprops.root.state.detail);
    console.log(this.loading);
    FX.doFocus(this);
    //var k = parseInt( this.props.root.state.detail , 10 );
    if( !this.loading && typeof this.props.root.state.detail === 'number'  ){
       this.loading = true;
       console.log(this.props.root.state.detail);
       this.retrieveDetail(this.props.root.state.detail);
    }
  }
  componentWillMount(){
     //FX.urlRetrieve.bind(this)(this.props.root.state);
  }
  componentDidMount(){
    console.log('oooo');
    this.retrieveData(0);
  }
  componentWillUnmount(){
    console.log('oooo');
    this.props.root.loadNextPage = undefined;
    this.props.root.autoKey = function(e){
      console.log(e);
    }
  }
  addActiveItem = () => {
    var found = false;
    var detail = this.props.root.state.detail;
    var delivery_items = this.props.root.state.detail.delivery_items;
    var activeProduct = this.state.activeProduct;
    if(this.props.root.state.detail.delivery_status < 10){
        delivery_items.some( (di, i) => {
            console.log(this.state.activeProduct.id);
            console.log(di);
            if(this.state.activeProduct.id === di.product_id){
              di.quantity += parseInt(document.getElementById('activeProductQty').value, 10);
              found = true;
            }
            return found;
        });
        if (!found  && parseInt(document.getElementById('activeProductQty').value, 10) ) {
          console.log(this.state.activeProduct.name);
          delivery_items.push({
            id:-1,
            product: activeProduct,
            delivery_id:  detail.id,
            product_id: activeProduct.id,
            quantity: parseInt(document.getElementById('activeProductQty').value, 10)
          });
        }
    }
    else {
        delivery_items.some( (di, i) => {
            console.log(this.state.activeProduct.id);
            console.log(di);
            if(this.state.activeProduct.id === di.product_id){
              alert("Product already in list");
              found = true;
            }
            return found;
        });
        if (!found) {
          console.log(this.state.activeProduct.name);
          delivery_items.push({
            id:-1,
            product: activeProduct,
            product_id: activeProduct.id,
            delivery_id:  detail.id,
            quantity: 0,
            received: parseInt(document.getElementById('activeProductQty').value, 10)
          });
        }

    }
    this.setState({activeProduct: null, additionalItem: false});
    this.props.root.setState({delivery_items : delivery_items});
  }
  removeItem = (prod) => {
    console.log(prod);
    var detail = this.props.root.state.detail;
    var delivery_items = this.props.root.state.detail.delivery_items;
    delivery_items.some( (di, i) => {
        if(prod === di.product_id){
          delivery_items.splice(i,1);
          return true;
        }
        return false;
    });
    this.props.root.setState({detail : detail});
  }
  removeShipItem = (ship) => {
    console.log(ship);
    var detail = this.props.root.state.detail;
    var ships = this.props.root.state.detail.composition;
    ships.some( (s, i) => {
        if(ship === s){
          ships.splice(i,1);
          return true;
        }
        return false;
    });
    this.props.root.setState({detail : detail});
  }
  showList = () => {
    FX.navigate.bind(this.props.root,this.props.root.state.panel, undefined ,'/deliveries')();
  }
  retrieveDetail = (id) => {
    console.log('pop');
    FX.load(this.props.root,'delivery/' + id , (res, i) => {
      console.log(res);
      if(res.delivery && res.delivery.id){
        this.props.root.setState({ detail : res.delivery  });
      }
      else {
          FX.navigate.bind(this.props.root,this.props.root.state.panel, undefined ,'/deliveries')();
      }
      this.loading = false;
    });
  }
  selectProduct = (prod) => {
    console.log(prod);
    console.log(this.props.root.state.detail.dispatch_items);
     this.focusTgt = 'activeProductQty';

    this.setState({activeProduct : prod})
  }
  scrollMore = (limit) => {
    if(!this.props.root.state.detail){
       this.retrieveData(limit);
    }
  }

  retrieveData = (limit, page) => {
    if(isNaN(limit)){
      limit = 30;
    }
    if(isNaN(page)){
      page = 0;
    }
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {customer_id: this.props.root.state.customer_id, sort: sort_str, limit: limit, page: page, /*sort:JSON.stringify(this.state.sort),*/ filter:JSON.stringify(this.state.filter)};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'delivery' + qs , (res, i) => {
      var currCust = this.props.root.state.current_customer;
      currCust[this.props.root.state.panel].list = res[this.props.root.state.panel];
      currCust[this.props.root.state.panel].count = res.count;
      currCust[this.props.root.state.panel].limit = res.limit;
      currCust[this.props.root.state.panel].pages = res.pages;
      currCust[this.props.root.state.panel].page = res.page;
      this.setState({page: res.page});
      Config.options.suppliers = res.suppliers;
      currCust[this.props.root.state.panel].data = data;
      currCust[this.props.root.state.panel].path = 'returns';
      this.props.root.setState({ current_customer : currCust  });
      console.log(res[this.props.root.state.panel]);
      this.props.root.loadNextPage =  this.scrollMore;
      console.log(Config.options.suppliers);
      var options = this.state.options;
      options.supplier_id = res.suppliers;
      this.setState({options:options});
    });
  }
  sortAction = ( sort , filter) => {
    console.log(sort);
    console.log(filter);
    var filters = [];
    if(filter.length){
      filter.forEach((filt) => {
        if (filt.active && filt.active.length){
          filters.push({field: filt.field, active: filt.active});
        }
      });
      console.log(filters);
    }
    this.setState({sort: sort, filter: filters}, this.retrieveData);
  }
  showProductModal = (prod_id) => {
     this.focusTgt = 'recBox';
     this.setState({productModal:prod_id, stockCount : ( parseInt(this.props.root.state.detail.delivery_status, 10) === 20 )});
  }
  showProductDetailModal = (prod_id) => {
     console.log(this.state);
     this.setState({productModal:prod_id, stockCount : false});
  }
  closeProductModal = (prod_id) => {
     this.setState({productModal:undefined, stockCount : false});
  }
  showNote = (prod_id) => {
     this.focusTgt = 'noteBox';
     this.setState({note : prod_id});
  }
  closeNote = () => {
     this.setState({note : undefined});
  }
  upImg = (e) => {

     console.log(e);
     console.log(e.nativeEvent);
     console.log(e.target);
     if(!e.target.files.length){
       return false;
     }
     var reader = new FileReader();

     reader.onload = (event) => {

         var pro;

         console.log(e);
         var current_customer = this.props.root.state.current_customer;
         //var detail = this.props.root.state.detail;
         current_customer.products.list.some((prod) =>{
            if(prod.id === this.state.productModal){
              pro = prod;
              return true;
            }
            return false;
         });

         console.log( this.state.productModal);
         console.log(pro);


          console.log(event);
          var dataUri = event.target.result,
          img = document.createElement("img");
          img.src = dataUri;
          img.className = 'img_new';
          // var width = img.width;
          // var height = img.height;
          // var fileSize = img.size;
          //alert(width);
          //alert(height);
          //alert(fileSize);
          document.getElementById('nu_img').appendChild(img);


        //var img = document.querySelector('.img_new');
        //var inu = FX.getBase64Image(img);

        pro.image.push({id: -1, add:true, img : event.target.result });
        console.log(img);
     };
     reader.onerror = function(event) {
         console.error("File could not be read! Code " + event.target.error.code);
     };
     reader.readAsDataURL(e.target.files[0]);

     console.log(e.target.files);

  }
  addShipmentElem = (e) => {
    var detail = this.props.root.state.detail;
    console.log(e);
    console.log(document.getElementById('shipmentType').value);
    console.log(document.getElementById('shipmentQty').value);
    var qty;
    if ( document.getElementById('shipmentType').value === 6){
      qty = Math.ceil(parseFloat(document.getElementById('shipmentQty').value, 10) * 4, 10)/4;
    }
    else {
      qty = parseInt(document.getElementById('shipmentQty').value, 10);
    }
    if(qty){
      if(!Array.isArray(detail.composition)){
        detail.composition = [];
      }
      var found = false;
      detail.composition.some(comp => {
        console.log(comp);
        if(parseInt(comp.shipment_type_id,10) === parseInt(document.getElementById('shipmentType').value,10)){
           comp.quantity = parseInt(comp.quantity,10) + qty;
           return found = true;
        }
        return found;
      })
      if(!found){
         detail.composition.push({'shipment_type_id':document.getElementById('shipmentType').value, quantity: qty});
      }
    }
    document.getElementById('shipmentType').value = '';
    document.getElementById('shipmentQty').value = '';
    this.focusTgt = "shipmentType";
    this.props.root.setState({detail:detail});
  }
  itemHandler = (prod, target, e) => {
    this.props.root.changed = true;
    console.log(prod);
    console.log(e);
    console.log(target);
    var detail = this.props.root.state.detail;
    var delivery_items =  detail.delivery_items;
    if(e.type === 'blur'){
      e.target.value = FX.numberFix(e.target.value);
    }
    var ex = false;
    delivery_items.some( (di, i) => {
        if(prod === di.product_id || prod === di.product.id ){
          di[target] = e.target.value;
          if( di.received === 0 && di.quantity === 0 && target === 'received'){
              console.log(window.confirm);
              if(window.confirm("Remove this product?")){
                this.removeItem(prod);
                ex = true;
              }
          }
          return true;
        }
        return false;
    });
    if(!ex){
      detail.delivery_items = delivery_items;
      this.props.root.setState({detail : detail});
    }

  }
  toJson = () => {
      var detail = this.props.root.state.detail;
      console.log(detail)
  }
  arrived = () => {
    var detail = this.props.root.state.detail;
    FX.load(this.props.root,'deliveryStatus' , (res, i) => {
          console.log(res);
          console.log(res.success);
          console.log('>>>>>>>>>>>>>>>>>>>>>>>');
          console.log(res);
          console.log(res.success);
          var current_customer = this.props.root.state.current_customer;
          if(res.suppliers){
              current_customer.suppliers = res.suppliers;
              this.props.root.setState({current_customer: current_customer});

          }
          if(res.success){
             console.log(res);
          }
          this.props.root.setState({detail : res.delivery});
          this.props.root.changed = false;
    }, {method:'POST',data:{detail : detail, delivery_id: detail.id, status_from: detail.delivery_status, status_to: 10}});
    console.log(this.props.root.state.detail);
  }
  save = () => {
    var detail = this.props.root.state.detail;
    if(!detail.reference){
      alert('You need to provide a reference number!');
      return false;
    }
    if(!detail.delivery_items.length){
      alert('You haven\'t entered any products.');
      return false;
    }
    if(detail.expected_delivery_date === null){
      alert('Please specify a delivery date.');
      return false;
    }
    // console.log(FX.dateFormat(new Date,'{Y}-{m2}-{d2}',detail.expected_delivery_date));
    // console.log(FX.dateFormat(detail.expected_delivery_date,'{Y}-{m2}-{d2}'));
    if(!detail.delivery_status && FX.dateFormat(new Date(),'{Y}-{m2}-{d2}',detail.expected_delivery_date) > FX.dateFormat(detail.expected_delivery_date,'{Y}-{m2}-{d2}')){
      alert('Please specify a delivery date in the future');
      return false;
    }
    FX.load(this.props.root,'delivery/save' , (res, i) => {
          var current_customer = this.props.root.state.current_customer;
          console.log('>>>>>>>>>>>>>>>>>>>>>>>');
          console.log(res);
          console.log(res.success);
          if(res.success || !res.error){
             if(res.suppliers){
                current_customer.suppliers = res.suppliers;
                this.props.root.setState({current_customer: current_customer});
             }
             console.log(res);
             this.props.root.setState({current_customer: current_customer, detail: res.delivery});
          }
          if(res.error_text){
             if(res.error === 1062){
                alert("This reference has been used before, please enter another");
             }
             else{
               alert(res.error_text);
             }
          }
          this.props.root.changed = false;
    }, {method:'POST', data:{detail: detail}});
    console.log(this.props.root.state.detail);
  }
  delete = () => {
    if(window.confirm("Deleting this Delivery is irreversible,\nare you sure you to delete?")){
        var detail = this.props.root.state.detail;
        FX.load(this.props.root,'delivery/delete' , (res, i) => {
              console.log(res);
              console.log(res.success);
              if(res.success){
                 console.log(res);
              }
              this.props.root.setState({detail : undefined});
              this.retrieveData();
        }, {method:'POST',data:{detail : detail}});
        console.log(this.props.root.state.detail);
    }
  }
  startProcessing = () => {
    var detail = this.props.root.state.detail;
    if(!detail.composition || !detail.composition.length){
      alert('Please specify the shipment composition');
      return false;
    }
    FX.load(this.props.root,'deliveryStatus' , (res, i) => {
          console.log(res);
          console.log(res.success);
          console.log('>>>>>>>>>>>>>>>>>>>>>>>');
          console.log(res);
          console.log(res.success);
          var current_customer = this.props.root.state.current_customer;
          if(res.suppliers){
              current_customer.suppliers = res.suppliers;
              this.props.root.setState({current_customer: current_customer});

          }
          if(res.success){
             console.log(res);
          }
          this.props.root.setState({detail : res.delivery});
          this.props.root.changed = false;
    }, {method:'POST',data:{detail : detail, delivery_id: this.props.root.state.detail.id, status_from: detail.delivery_status, status_to: 20 }});
    console.log(this.props.root.state.detail);
  }
  endProcessing = () => {
    this.toJson();
    console.log(this.props.root.state.detail);
    var delivery_items = this.props.root.state.detail.delivery_items;
    var perfect = true;
    var errors = [];
    var detail = this.props.root.state.detail;
    var msg;
    delivery_items.forEach(di => {
      if(parseInt(di.received, 10) !== parseInt(di.quantity, 10)){
        errors.push(di);
        perfect = false;
      }
      di.received = parseInt(di.received, 10)
    })
    console.log(perfect);
    console.log(delivery_items);
    //var err_list = null;
    if( perfect ){
        msg = "This Delivery will be marked as received without errors and booked into stock";
        //err_list = null;
    }
    else{
        msg = "This Delivery will be marked as received with discrepancies and booked into stock";
        // err_list = errors.map(err => {
        //   return <div>{err.product.name} - Expected {err.quantity}, received {err.received}</div>
        // })
    }
    if(window.confirm(msg)){
        FX.load(this.props.root,'deliveryComplete' , (res, i) => {
              var current_customer = this.props.root.state.current_customer;
              console.log(res);
              console.log(res.success);
              console.log('>>>>>>>>>>>>>>>>>>>>>>>');
              console.log(res);
              console.log(res.success);
              if(res.suppliers){
                  current_customer.suppliers = res.suppliers;
                  this.props.root.setState({current_customer: current_customer});

              }
              if(res.success){
                 console.log(res);
              }
              this.props.root.setState({detail : res.delivery});
              this.props.root.changed = false;
        }, {method:'POST',data:{ detail : detail }});
    }
  }

  isAdmin = () => {
    var user = this.props.root.state.user;
    return parseInt(user.admin_level, 10);
  }
  enterAction = {
    'recBox': (e)=> {
      if(parseInt(e.target.id.split('_')[0],10)){
        console.log('zing');
      }
      console.log(e.key);
      e.target.blur();
      this.closeProductModal();
    },
    'activeProductQty' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.addActiveItem();
    },
    'shipmentQty' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.addShipmentElem();
    }
  }
  contextHide = () => {
      this.setState({showCalendar:null});
  }
  additionalItem = () => {
      this.setState({additionalItem: true});
      this.focusTgt = 'prod_search';
  }
  showCalendar = (tgt, e) => {
    var detail = this.props.root.state.detail;
    console.log(e);
    console.log(e.type);
    console.log([e.clientX,e.clientY]);
    var loc;
    if(e.type === 'focus'){
      loc = e.target.getBoundingClientRect();
      console.log(loc);
      loc = [loc.left,loc.bottom];
    }
    else {
      loc =  [e.clientX,e.clientY];
    }
    console.log(loc);
    if(0 === parseInt(detail.delivery_status,10) && (tgt === 'expected' || tgt === 'expiry')){
        this.setState({showCalendar: {location: loc, target: tgt}});
    }
  }
  handle = (tgt, e) => {
      this.props.root.changed = true;
      var detail = this.props.root.state.detail
      console.log(e)
      detail[tgt] = e.target.value;
      this.props.root.setState(detail);
  }
  handleSupplier = (value, e) => {
      this.props.root.changed = true;
      var detail = this.props.root.state.detail
      console.log(value)
      console.log(e)
      detail.supplier = value;
      this.props.root.setState(detail);
  }
  contextHide = () => {
    this.setState({context: false});
  }
  contextShow = (oi, e) => {
    var detail = this.props.root.state.detail;
    var options = [
        {title: "View Product",action:()=>{FX.navigate.bind(this.props.root, 'products'  , undefined ,'/products/'+oi.product.id)() }}

    ]
    if(detail.delivery_status < 50){
      options.push({title: "Edit Product",action:()=>{ this.showProductModal(oi.product.id) }});
    }
    this.setState({context : {show: true, location: [e.clientX,e.clientY], options: options}});
  }
  productHandler = (target, e) => {
      this.props.root.changed = true;
      var pro;
      var current_customer = this.props.root.state.current_customer;
      var detail = this.props.root.state.detail;
      current_customer.products.list.some((prod) =>{
        if(prod.id === this.state.productModal){
          prod[target] = e.target.value;
          pro = prod;
          return true;
        }
        return false;
      });
      detail.delivery_items.some((di) =>{
        console.log(di);
        if(pro.id === di.product.id){
          di.product = pro;
          return true;
        }
        return false;
      });
      this.props.root.setState({current_customer: current_customer});
  }
  saveProduct = (e) => {
      console.log(e);
      var pro;
      var current_customer = this.props.root.state.current_customer;
      var detail = this.props.root.state.detail;
      current_customer.products.list.some((prod , i) =>{
        if(prod.id === this.state.productModal){
          pro = prod;
          return true;
        }
        return false;
      });
      FX.load(this.props.root,'product' , (res, i) => {
          console.log("Product Saved");
          console.log(res);
          console.log(res.success);
          if(res.product){
              current_customer.products.list.some((prod, k) =>{
                if(prod.id === res.product.id){
                  //prod = res.product;
                  current_customer.products.list[k] = res.product;
                  prod.updated1 = '010';
                  console.log('___________');
                  return true;
                }
                return false;
              });
              detail.delivery_items.some((di) =>{
                  console.log(res);
                if(res.product.id === di.product.id || res.product.id === di.product_id){
                  console.log(di);
                  di.product = res.product;
                  di.product.updated2 = '011';
                  return true;
                }
                return false;
              });
              console.log(current_customer);
              this.props.root.setState({current_customer: current_customer, detail:detail});

          }
          if(res.success){
             console.log(res);

              current_customer.products.list.some((prod , i) =>{
                if(prod.id === this.state.productModal){
                  //current_customer.products.list[i] = res.product;
                  //this.props.root.setState({current_customer: current_customer, detail:detail});
                  return true;
                }
                return false;
              });

             this.closeProductModal();
          }
    }, {method:'PUT',data:{ product : {id : pro.id,locations: pro.locations, barcode : pro.barcode, images : pro.image} }}, true);
    console.log(pro);
  }
  removeLocation = (pro, target, e) => {
      console.log(e);
      var current_customer = this.props.root.state.current_customer;
      current_customer.products.list.some((prod) =>{
        if(prod.id === pro.id){
          prod.locations.splice(target,1);
          return true;
        }
        return false;
      });
      this.setState({current_customer: current_customer});
  }
  addLocation = (pro, e) => {
      console.log(e);
      console.log(pro);
      var newLoc;
      if(document.getElementById("addLocation") && (newLoc = document.getElementById("addLocation").value)){
          var current_customer = this.props.root.state.current_customer;
          current_customer.products.list.some((prod) =>{
            if(prod.id === pro.id){
              prod.locations.push({id: -1, warehouse_id: 1, reference: newLoc, product_id: pro.id});
              return true;
            }
            return false;
          });
          this.setState({current_customer: current_customer});
      }
      document.getElementById("addLocation").value = '';
  }
  addExpiryDate = () => {
    var detail = this.props.root.state.detail;
    var delivery_items =  detail.delivery_items;
    if(this.state.productModal){
        delivery_items.some( (di, i) => {
            if(this.state.productModal === di.product_id || this.state.productModal === di.product.id ){
              try {
                   di.expiry = JSON.parse(di.expiry_list);
                   if (!di.expiry){
                     di.expiry = [];
                   }
                 }
                 catch(e){
                   di.expiry = [];
                   console.log(e);
                 }
                di.expiry.push({date:document.getElementById("newExpDate").value, lot: document.getElementById("newExpLot").value,  quantity: document.getElementById("newExpQty").value});
                di.expiry_list = JSON.stringify(di.expiry);
                document.getElementById("newExpDate").value = '';
                document.getElementById("newExpLot").value = '';
                document.getElementById("newExpQty").value = '';



              return true;
            }
            return false;
        });
        detail.delivery_items = delivery_items;
        this.props.root.setState({detail : detail});
                   console.log(detail);
    }
  }
  deleteExpiryDate = (index) => {
    var detail = this.props.root.state.detail;
    var delivery_items =  detail.delivery_items;
    if(this.state.productModal){
        delivery_items.some( (di, i) => {
            if(this.state.productModal === di.product_id || this.state.productModal === di.product.id ){
              try {
                   di.expiry = JSON.parse(di.expiry_list);
                   di.expiry.splice(index, 1);
                 }
                 catch(e){
                   di.expiry = [];
                   console.log(e);
                 }
                di.expiry_list = JSON.stringify(di.expiry);
              return true;
            }
            return false;
        });
        detail.delivery_items = delivery_items;
        this.props.root.setState({detail : detail});
        console.log(detail);
    }
  }
  storeMouseData = (e) => {
    window.clickLocation = [e.clientX,e.clientY];
  }
  setPreOrder = (item) => {
    console.log(item);
    item.show = true;
    this.props.root.forceUpdate();
  }
  addDelivery = () => {
    var detail = {
        id:-1,
        customer_id:this.props.root.state.customer_id,
        reference:"",
        delivery_status:0,
        import_status:0,
        expected_delivery_date: null,
        arrived_date:null,
        received_date:null,
        supplier_id:0,
        return:0,
        notes:null,
        archived:false,
        delivery_items:[],
        composition:[]
    }
    this.props.root.setState({detail:detail});
  }
  print = () => {
    window.open(apiHost + "/v1/export_delivery?ref=" + this.props.root.state.detail.id, "_blank");
  }
  toggleSide = () => {
    this.setState({showSide:!this.state.showSide});
  }
  render() {
    if(this.props.root.state.detail && typeof this.props.root.state.detail !== 'number'){
      var detail = this.props.root.state.detail;
      var isAdmin = !this.props.root.state.user.customer_id_list;
      console.log(Config.options.deliveries);
      var th;

      var di = detail.delivery_items.map( item => {
        var noteBtn = '';
        var noteBtnClass = '';
        var pre_orderable;

        if(item.show || item.allow_pre_order){
          pre_orderable = <input className="numBox" title="Click to enable, then enter the amount of stock you wish to allow to be pre-ordered."  data-max={item.quantity} defaultValue={item.quantity} onChange={FX.limit.bind( this, this.itemHandler.bind(this,item.product.id,'allow_pre_order'), item)} value={item.allow_pre_order} />;
        }
        else {
          pre_orderable = <input className="numBox" title="Enter the amount of stock you wish to allow to be pre-ordered." type="checkbox" checked={parseInt(item.allow_pre_order,10)} onClick={this.setPreOrder.bind(this,item)} />;
        }
        if(item.note ){
          noteBtn = noteBtnClass = 'insert_comment';
        }
        else if( detail.delivery_status < 50){
          noteBtn = noteBtnClass = 'add_comment';
        }

        //var barcode = '';
        if (parseInt(detail.delivery_status, 10) < 10){
          var lineStatus = 'ok';
          if(0===item.received){
            lineStatus = 'unreceived'
          }
          else if(item.quantity===0){
            lineStatus = 'unexpected'
          }
          else if(item.quantity!==item.received){
            lineStatus = 'short'
          }

          th = (
            <tr>
              <th></th>
              <th>Product</th>
              <th>Note</th>
              <th>Expected</th>
              <th>Pre-Orderable <i  title="Click to enable, then enter the amount of stock you wish to allow to be pre-ordered." className="fa fa-question-circle" aria-hidden="true"></i></th>
              <th></th>
            </tr>
          )

          /*
          <tr>
            <td>{item.product.sku} - {item.product.name}</td>
            <td>{item.product.barcode}</td>
            <td><i onClick={this.showProductModal.bind(this, item.product.id)} className="material-icons">edit</i></td>
            <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
            <td><input onClick={(e)=>{e.target.setSelectionRange(0, e.target.value.length)}} className="numBox"  onChange={this.itemHandler.bind(this,item.product.id, 'quantity')} value={item.quantity}/></td>
            <td>{pre_orderable}</td>
            <td><i onClick={this.removeItem.bind(this, item.product_id)} className="material-icons">close</i></td>
          </tr>
          */



          // if(item.product.barcode){
          // barcode = (<span className="product_barcode">{item.product.barcode}</span>)
          // }

          return (
            <tr className={'line ' + lineStatus}>
                <td><input type="checkbox" className="product_check" onClick={this.reRender} data-delivery_item_id={item.id}/></td>
                <td>
                  <span className="product_name">{item.product.name}</span>
                  <span className="product_sku">{item.product.sku}</span>
                </td>
                <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
                <td className="product_quantity">{item.quantity}</td>
                <td>{pre_orderable}</td>
                <td>
                  <span className="product_menu" onClick={this.contextShow.bind(this,item)}><i className="fa fa-ellipsis-v" /></span>
                  <i onClick={this.removeItem.bind(this, item.product_id)} className="material-icons product_remove">close</i>
                </td>
            </tr>
          )
        }
        else if (parseInt(detail.delivery_status, 10) < 20){

          /*
          return (
              <tr className={'line ' + lineStatus}>
                <td>{item.product.sku} - {item.product.name}</td>
                <td>{item.product.barcode}</td>
                <td><i onClick={this.showProductModal.bind(this, item.product.id)} className="material-icons">edit</i></td>
                <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
                <td>{item.quantity}</td>
                <td><input onClick={(e)=>{e.target.setSelectionRange(0, e.target.value.length)}} id={"recBox_" + item.product.id} className="numBox recBox" value={item.received} onChange={this.itemHandler.bind(this,item.product.id, 'received')} onBlur={this.itemHandler.bind(this,item.product.id, 'received')} /></td>
              </tr>
            )
           */

          th = (
            <tr>
              <th></th>
              <th>Product</th>
              <th>Note</th>
              <th>Expected</th>
              <th></th>
            </tr>
          )

          // if(item.product.barcode){
          //   barcode = (<span className="product_barcode">{item.product.barcode}</span>)
          // }
          return (  
            <tr className={'line ' + lineStatus}>
              <td><input type="checkbox" className="product_check" onClick={this.reRender} data-delivery_item_id={item.id}/></td>
              <td>
                <span className="product_name">{item.product.name}</span>
                <span className="product_sku">{item.product.sku}</span>
              </td>
              <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
              <td className="product_quantity">{item.quantity}</td>
              <td>
                <span className="product_menu" onClick={this.contextShow.bind(this,item)}><i className="fa fa-ellipsis-v" /></span>
              </td>
            </tr> 
          )
        }
        else if (parseInt(detail.delivery_status, 10) < 50){
          /*
          return (
            <tr className={'line ' + lineStatus}>
              <td>{item.product.sku} - {item.product.name}</td>
              <td>{item.product.barcode}</td>
              <td><i onClick={this.showProductModal.bind(this, item.product.id)} className="material-icons">edit</i></td>
              <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
              <td>{item.quantity}</td>
              <td><input onClick={(e)=>{e.target.setSelectionRange(0, e.target.value.length)}} id={"recBox_" + item.product.id} className="numBox recBox" value={item.received} onChange={this.itemHandler.bind(this,item.product.id, 'received')} onBlur={this.itemHandler.bind(this,item.product.id, 'received')} /></td>
            </tr>
           )
          */

          th = (
            <tr>
              <th></th>
              <th>Product</th>
              <th>Note</th>
              <th>Expected</th>
              <th>Received</th>
              <th></th>
            </tr>
          )

          // if(item.product.barcode){
          //   barcode = (<span className="product_barcode">{item.product.barcode}</span>)
          // }
          return (  
            <tr className={'line ' + lineStatus}>
              <td><input type="checkbox" className="product_check" onClick={this.reRender} data-delivery_item_id={item.id}/></td>
              <td>
                <span className="product_name">{item.product.name}</span>
                <span className="product_sku">{item.product.sku}</span>
              </td>
              <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
              <td className="product_quantity">{item.quantity}</td>
              <td><input onClick={(e)=>{e.target.setSelectionRange(0, e.target.value.length)}} id={"recBox_" + item.product.id} className="numBox recBox" value={item.received} onChange={this.itemHandler.bind(this,item.product.id, 'received')} onBlur={this.itemHandler.bind(this,item.product.id, 'received')} /></td>
              <td>
                <span className="product_menu" onClick={this.contextShow.bind(this,item)}><i className="fa fa-ellipsis-v" /></span>
              </td>
            </tr> 
          )
        }
        else if  (parseInt(detail.delivery_status, 10) >= 50) {

          th = (
            <tr>
              <th>Product</th>
              <th>Note</th>
              <th>Expected</th>
              <th>Received</th>
              <th></th>
            </tr>
          )

          // if(item.product.barcode){
          //   barcode = (<span className="product_barcode">{item.product.barcode}</span>)
          // }

          return (
            <tr className={'line ' + lineStatus}>
              <td>
                <span className="product_name">{item.product.name}</span>
                <span className="product_sku">{item.product.sku}</span>
              </td>
              <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
              <td>{item.quantity}</td>
              <td>{item.received}</td>
              <td>
                <span className="product_menu" onClick={this.contextShow.bind(this,item)}><i className="fa fa-ellipsis-v" /></span>
              </td>
            </tr>
           )
        }
        else {

          th = (
            <tr>
              <th>Product</th>
              <th>Note</th>
              <th>Quantity</th>
              <th>Received</th>
            </tr>
          )

          // if(item.product.barcode){
          //   barcode = (<span className="product_barcode">{item.product.barcode}</span>)
          // }

          return (
            <tr className={'line ' + lineStatus}>
              <td>
                <span className="product_name">{item.product.name}</span>
                <span className="product_sku">{item.product.sku}</span>
              </td>
              <td><i onClick={this.showProductModal.bind(this, item.product.id)} className="material-icons">edit</i></td>
              <td className={noteBtnClass}><i onClick={this.showNote.bind(this, item.product.id)} className="material-icons">{noteBtn}</i></td>
              <td>{item.quantity}</td>
              <td>{item.received}</td>
              <td>
                <span className="product_menu" onClick={this.contextShow.bind(this,item)}><i className="fa fa-ellipsis-v" /></span>
              </td>
            </tr>
          )
        }
      });
      var productModal;
      if(this.state.productModal){
        var pro;
        var item;
        if(this.props.root.state.current_customer.products){
          this.props.root.state.current_customer.products.list.some((prod) =>{
            if(prod.id === this.state.productModal){
              pro = prod;
              return true;
            }
            return false;
          })
        }
        var locations;
        var images;
        if(pro){
          detail.delivery_items.some((di) =>{
            if(di.product.id === this.state.productModal){
              item = di;
              return true;
            }
            return false;
          })
           console.log(pro);

            if(pro.locations && Array.isArray(pro.locations)){
              locations = pro.locations.map( (loc,i) => {
                return (
                  <div className="location">
                    {loc.reference}
                    <i style={{float: 'right'}} onClick={this.removeLocation.bind(this, pro, i)} className="material-icons">close</i>
                  </div>
                );
              });
            }
            images = pro.image.map( img => {
            console.log(img);
             return (
                <div className="image">
                  <img src={this.props.root.paths.imgHost + img.path} alt="Material" title="Material" />
                  <i style={{float: 'right'}} className="material-icons">close</i>
                </div>
              );
            });
            if(isAdmin){
            locations = (
              <div className="locations">
                  <h4>Locations</h4>
                  <Scrollbars style={{ width: 200 }}>
                      {locations}
                      <div className="add_location"><i className="material-icons">add_circle_outline</i><input id="addLocation"/><button onClick={this.addLocation.bind(this,pro)}><i className="material-icons">add</i></button></div>
                  </Scrollbars>
              </div>
            );
           }
        if(!this.state.stockCount){
             productModal = (<Modal buttons={[{text:'Cancel',action:this.closeProductModal},{text:'Save',action:this.saveProduct}]} close={this.closeProductModal} title="Product" >

                            <div>
                                <div>{pro.sku} - {pro.name}</div>
                                <div><label>Barcode:</label><input value={pro.barcode} onChange={this.productHandler.bind(this,'barcode')} /></div>


                                <div className="images">
                                <h4>Images</h4>
                                    {images}
                                    <div id="nu_img"></div>
                                    <div className="add_image">&nbsp;<i className="material-icons">add_circle_outline</i><input id="newImg" type="file" onChange={this.upImg} /></div>
                                </div>
                                {locations}
                            </div>


                        </Modal>);
         }
         else {
          var new_exps;
          if(!Array.isArray(item.expiries)){
            item.expiry = [{date: '2017-11-29'}];
          }
          try {
            item.expiry = JSON.parse(item.expiry_list);
            if (!item.expiry){
              item.expiry = [];
            }
          }
          catch(e){
            item.expiry = [];
            console.log(e);
          }

          new_exps = item.expiry.map((ex,i) => {
              return (<tr><td>{ex.date}</td><td>{ex.lot}</td><td>{ex.quantity}</td><td><i onClick={this.deleteExpiryDate.bind(this, i)} className="material-icons">close</i></td></tr>)
          })

          var cal;
          if (this.state.showCalendar && this.state.showCalendar.target === 'expiry'){
            cal = (
                <ContextMenu show={true} location={this.state.showCalendar.location} parent={this}>
                    <Calendar date={new Date()} close={(date) => {document.getElementById("newExpDate").value= FX.dateFormat(date,'{Y}-{m2}-{d2}'); this.props.root.setState({detail:detail}); this.setState({showCalendar:false})}} range={false} />
                </ContextMenu>
            )
          }



          new_exps = (<table>{new_exps}</table>);
          productModal = (<Modal close={this.closeProductModal} buttons={[{text: "Edit Product", action: this.showProductDetailModal.bind(this, this.state.productModal)},{text: "OK", action: this.closeProductModal}]} title="Stock Received" >
                            <div>
                                <div>{item.product.name}</div>
                                <div>Receieved: <input className="numBox" type="text"  id="recBox" value={item.received} onChange={this.itemHandler.bind(this,item.product.id, 'received')} /></div>
                                <div className="product_stock_ctrl">
                                  <div>Expiries:</div>
                                  {new_exps}
                                  {cal}
                                  <div>
                                      <input className="dateBox" onFocus={this.showCalendar.bind(this,'expiry')} onClick={this.storeData} type="text"  id="newExpDate"/>
                                      <input className="miniText" type="text"  id="newExpLot"/>
                                      <input className="numBox" type="text"  id="newExpQty"/>
                                      <button onClick={this.addExpiryDate}><i className="material-icons">add</i></button>
                                  </div>
                                </div>
                            </div>
                        </Modal>);
          }
        }
      }
      var noteModal;
      if(this.state.note){
        console.log(this.state.note);
            //var pro;
            //var item;
            if(this.props.root.state.current_customer.products){
              this.props.root.state.current_customer.products.list.some((prod) =>{
                if(prod.id === this.state.note){
                  pro = prod;
                  return true;
                }
                return false;
              })
           }
          detail.delivery_items.some((di) =>{
            if(di.product.id === this.state.note){
              item = di;
              return true;
            }
            return false;
          })
          console.log(pro);
          console.log(detail.delivery_status >= 50);
          console.log(this.state.note);
          console.log(detail.delivery_items);

          noteModal = (
              <Modal buttons={[{text:'OK',action:this.closeNote}]} close={this.closeNote} title= { "Note - " + item.product.sku + ' - ' + item.product.name} >
                  <div>
                      <textarea disabled={detail.delivery_status >= 50} id="noteBox" value={item.note} onChange={this.itemHandler.bind(this,item.product.id, 'note')} />
                  </div>
              </Modal>
         );
      }
      var nextStep;
      //var modalMenu;
      var additionalItem;

      if(isAdmin) {
        if(parseInt(detail.delivery_status, 10) < 10 && detail.id > 0){
          nextStep = <button className="nextStep" onClick={this.arrived}>Mark Arrival <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></button>
        }
        else if(parseInt(detail.delivery_status, 10) < 20 && detail.id > 0){
          nextStep = <button className="nextStep" onClick={this.startProcessing}>Start Processing <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></button>
          additionalItem = (
            <button onClick={this.additionalItem}>
                Additional Item Received
            </button>
            );
        }
        else if(parseInt(detail.delivery_status, 10) < 30 && detail.id > 0){
          nextStep = <button className="nextStep" onClick={this.endProcessing}>Complete Delivery <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></button>
          additionalItem = (
            <button onClick={this.additionalItem}>
                Additional Item Received
            </button>
            );
        }
      }

      var active;
      if (this.state.activeProduct){
        active = (
          <div className="activeProduct">{this.state.activeProduct.sku} - {this.state.activeProduct.name} <input id="activeProductQty" defaultValue="0" disabled={parseInt(detail.delivery_status,10)=== 10}/><button onClick={this.addActiveItem} ><i className="material-icons">add</i></button></div>
        );
      }
      var searchbox = <div className="no-search"/>;
      if( parseInt(detail.delivery_status, 10) < 10 || this.state.additionalItem ){
        searchbox = <SearchBox parent={this} root={this.props.root}></SearchBox>
      }
      var calendar;
      if (this.state.showCalendar && this.state.showCalendar.target === 'expected'){

        calendar = (
            <ContextMenu show={true} location={this.state.showCalendar.location} parent={this}>
                <Calendar date={detail.expected_delivery_date} close={(date) => {detail.expected_delivery_date = FX.dateFormat(date,'php'); this.props.root.setState({detail:detail}); this.setState({showCalendar:false})}} range={false} />
            </ContextMenu>
        )
      }
      var supplier;
      var supplierName;
      if(this.props.root.state.current_customer.suppliers){
        this.props.root.state.current_customer.suppliers.some(sup => {
            if (detail.supplier_id === sup.id) {
               supplier = sup.name;
               return true;
            }
            return false;
        })
        if (detail.delivery_status >= 50) {
           supplierName = supplier;
        }
        else {
        supplierName = (
            <ComboBox id="supplier_box" defaultValue={supplier} onChange={this.handleSupplier} options={this.props.root.state.current_customer.suppliers} />
        )
       }
      }
      var expected_delivery_date;
      console.log(detail.delivery_status);
      if(0 === parseInt(detail.delivery_status,10) && detail.expected_delivery_date!==null){
           expected_delivery_date = (<div className="expected_delivery_date" onClick={this.showCalendar.bind(this,'expected')}>
              Expected: {FX.dateFormat(detail.expected_delivery_date,'{d2}/{m2}/{Y}')}
            </div>)
      }
      else if(0 === parseInt(detail.delivery_status,10)){
           FX.dateFormat(new Date(),'{Y}-{m2}-{d2}');
           expected_delivery_date = (<div className="expected_delivery_date unset" onClick={this.showCalendar.bind(this,'expected')}>
              Specify delivery date
            </div>);
      }
      else {
           expected_delivery_date = (<div className="expected_delivery_date" >
              Expected: {FX.dateFormat(detail.expected_delivery_date,'{d2}/{m2}/{Y}')}
            </div>);
      }
      var shipment;
      if(parseInt(detail.delivery_status,10) > 0 && parseInt(detail.delivery_status,10) < 50){
      var shipmentOptions;
      var shipmentDetail;
      if(this.props.root.state.current_customer.shipment_types){
        if(detail.composition){
          shipmentDetail = detail.composition.map(ship => {
              var ship_type;
              this.props.root.state.current_customer.shipment_types.some(st => {
                if(ship.shipment_type_id === st.id){
                   ship_type = st.name;
                   return true;
                }
                return false;
              });
              return (<div className="shipmentItem">{ship_type} - {ship.quantity}  <i onClick={this.removeShipItem.bind(this, ship)} className="material-icons">close</i></div>);
          });
        }
        shipmentOptions = this.props.root.state.current_customer.shipment_types.map(ship => {
            return (<option value={ship.id}>{ship.name}</option>);
        });


         shipment =(
            <div className="shipment">
              <h5>Shipment Composition</h5>
              <div className="shipmentDetail">
                {shipmentDetail}
              </div>
              <select id="shipmentType" onChange={(e) => { console.log('xxx'); document.getElementById('shipmentQty').focus(); }} onClick={(e) => { this.focusTgt = 'shipmentQty'; }}>
                <option value="">----</option>
                {shipmentOptions}
              </select>
              <input className="numBox" id="shipmentQty" />
              <button onClick={this.addShipmentElem}><i className="material-icons">add</i></button>
            </div>
        )

        }

      }
      else if (parseInt(detail.delivery_status,10) >= 50) {
      if(this.props.root.state.current_customer.shipment_types){
        if(detail.composition){
          shipmentDetail = detail.composition.map(ship => {
              var ship_type;
              this.props.root.state.current_customer.shipment_types.some(st => {
                if(ship.shipment_type_id === st.id){
                   ship_type = st.name;
                   return true;
                }
                return false;
              });
              return (<div className="shipmentItem">{ship_type} - {ship.quantity} </div>);
          });
        }
         shipment =(
            <div className="shipment">
              <h5>Shipment Composition</h5>
              <div className="shipmentDetail">
              {shipmentDetail}
              </div>
            </div>
            );
        }
      }
      var sideButtons;
      if (parseInt(detail.delivery_status,10) >= 50) {
        sideButtons = (
            <div id="sideButtons">
              <button  onClick={this.showList}>Back</button>
            </div>
        )
      }
      else {
        sideButtons = (
            <div id="sideButtons">
              <button  onClick={this.delete}>Delete</button>
              <button  onClick={this.showList}>Back</button>
              <button onClick={this.save}>Save</button>
            </div>
        )
      }
      var reference;
      console.log(detail.delivery_status);
      if(parseInt(detail.delivery_status,10)){
        reference = <div className="reference">{detail.reference}<span>{detail.id}</span></div>
      }
      else {
        reference = <div className="reference"><input id="reference" placeholder="Please Enter Reference" value={detail.reference} onChange={this.handle.bind(this,'reference')} /></div>
      }
      var print_button;
      if(this.isAdmin() && detail.delivery_status >= 10){
          print_button = (
            <button className="print_button" onClick={this.print} >Print Delivery Sheet</button>
            )
      }
      var admin_buttons = (<div>{print_button}{nextStep}</div>)
      var sideBar,toggleSide;
      if(this.state.showSide){
          sideBar = (
            <div id="SideBar">
              {reference}
              <div className="status">{FX.status('deliveries',detail.delivery_status)}</div>
              {calendar}
              {expected_delivery_date}
              <div className="supplier">
              <h4>Supplier</h4>
              {supplierName}
              </div>
              {shipment}
              {sideButtons}
            </div>
          );
          toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>Hide</div>);
      }
      else {
         toggleSide = (<div className="toggleSide" onClick={this.toggleSide}>Show</div>);
      }
      return (
        <div className="Delivery">
          {toggleSide}
          <button className="backBtn" onClick={this.showList}><i className="fa fa-angle-left" />  Back</button>
          {searchbox}
          {active}
          <input id="item_search"/>
          {productModal}
          {noteModal}
          {admin_buttons}
          <table className="itemList">
            {th}
            {di}
          </table>
          <ContextMenu root={this.props.root} options={this.state.context.options}  location={this.state.context.location} parent={this} show={this.state.context.show} />
          {additionalItem}
          {sideBar}
        </div>
      );
    }
    else {
      return (
        <div className="Deliveries">
          <div className="controls">
              <button onClick={this.addDelivery}><i className="fa fa-plus" aria-hidden="true" /> Add Delivery</button>
          </div>
          <List selectable={true} sortAction={this.sortAction} showState={true} root={this.props.root} clickAction={Config.tables.deliveries.click} options={this.state.options} display={{object:"delivery", items:this.props.root.state.current_customer.deliveries}} model={Config.tables.deliveries} setPage={this.setPage} />
        </div>
      );
    }
  }
}

export default Delivery;



// WEBPACK FOOTER //
// ./src/Delivery.js